import { Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl,ValidatorFn, FormGroup } from '@angular/forms';
import { MatAutocompleteSelectedEvent, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { RootScopeService } from 'src/app/services/root-scope.service';
import { FormBuilder,  FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { invalid } from 'moment';

@Component({
  selector: 'app-alight-smart-search-drop-down',
  templateUrl: './alight-smart-search-drop-down.component.html',
  styleUrls: ['./alight-smart-search-drop-down.component.scss']
})
export class AlightSmartSearchDropDownComponent implements OnInit, OnChanges {

  @Input() group: FormGroup = new FormGroup({}); 
  @Input() controlName: string = ''; 
  @Input() autofocus: boolean = false; 
  @Input() list: Array<any> = new Array<any>(); 
  @Input() label: string = 'name'; 
  @Input() value: string = ''; 
  @Input() disable: boolean = false; 
  @Input() required: boolean = false; 
  @Input() description: string = '';
  @Input() selectedValue: any;
  @Input() clearSeleAvailable: boolean = false; 
  @Output() changeEvent = new EventEmitter();
  @Output() focusoutEvent = new EventEmitter();
  @Output() optionSelectedEvent = new EventEmitter();
  @Output() clientChanged = new EventEmitter();
  @Output() clearEvent = new EventEmitter<boolean>(); 

   // Below code to be used and to be removed from multiple places once all the dropdowns are made common.
   @ViewChild(MatAutocompleteTrigger) matAutocompleteTrigger!: MatAutocompleteTrigger;
   @HostListener('window:scroll', [])
   onScroll(): void {
     if (this.matAutocompleteTrigger && this.matAutocompleteTrigger.panelOpen) {
       this.matAutocompleteTrigger.closePanel();
     }
   }
 
  filteredList: any = [];
  currSelectedValue:any ;
  prevSelectedCLient: any;
  optionSelected: any;
  
  constructor(public rootScope: RootScopeService) {
    const selectedItem = this.filteredList.find(item => item.clientId === this.group.get(this.controlName)?.value);
    this.currSelectedValue = selectedItem?.clientName;

   
   }

  ngOnInit(): void { 
    this.filteredList = this.list;
  
    let formControl = this.group.get(this.controlName) as FormControl;
    this.rootScope.smartSearchData.isInvalidCustomerClient = false;
    this.rootScope.smartSearchData.isInvalidDashboardClient = false;
      formControl?.markAsUntouched();
      formControl?.markAsPristine();
      formControl?.setErrors(null);
      /* istanbul ignore next */
    setTimeout(() => {
      this.filteredList = this.list; 
    }, 500);
    formControl?.valueChanges.subscribe(value => {
      this.filteredList = this.list;
      this.filteredList = this.filterOptions(value);
    });
    //this.rootScope.smartSearchData.isInvalidCustomerClient=false
    const selectedItem = this.filteredList.find(item => item.clientName === formControl?.value);
    this.currSelectedValue = selectedItem?.clientName;
   
    //formControl.setValue(this.currSelectedValue);
  }


  ngOnChanges(): void {
    let formControl = this.group?.get?.(this.controlName) as FormControl;
    this.checkInvalidClient(formControl?.value);
  }



  filterOptions(value: string): any[] {
   // this.optionSelected =false;
    const filterValue = value?.toLowerCase();
    if(this.list?.length ==0){
      return [];
    }
   
    if(this.controlName == 'clientName')
       this.rootScope.customerSearchForm.value.clientName = value;
    let formControl = this.group.get(this.controlName) as FormControl;
    let filteredlist= this.list?.filter(option => option[this.description]?.toLowerCase()?.startsWith(filterValue));
   if(this.controlName == 'clientNameDash'){
    if(filteredlist?.length == 0){
         this.rootScope.smartSearchData.isInvalidDashboardClient = true;
         formControl?.setErrors({invalidDashboardClient:true});
         formControl?.markAllAsTouched();
    }
    else{
      this.rootScope.smartSearchData.isInvalidDashboardClient = false;
      //formControl.setErrors(null);
    }
   }
  else if(this.controlName == 'clientName'){
    if(filteredlist?.length == 0 ){
      this.rootScope.smartSearchData.isInvalidCustomerClient = true;
      formControl?.setErrors({invalidClient:true});
      formControl?.markAllAsTouched();
    }
    else{
      this.rootScope.smartSearchData.isInvalidCustomerClient = false;
    //  formControl.setErrors(null);
    }
   }

   else if (this.controlName == 'SIM_clientName') {

     if (filteredlist?.length == 0) {
       formControl?.setErrors({ invalidClient: true });
       formControl?.markAllAsTouched();
     }
     else {
       if (filteredlist?.[0]?.clientName != value) {
         this.group.get('clientId')?.setValue('');
       } else if (filteredlist?.[0]?.clientName == value) {
         this.group.get('clientId')?.setValue(filteredlist?.[0]?.clientId);
       }
     }
  }
   
    return filteredlist;
  }
  
  typeHeadChange(event: MatAutocompleteSelectedEvent) {
    // Emit the change event only when an option is selected
   
    let formControl = this.group.get(this.controlName) as FormControl;
    let formControlClientId = this.group.get('clientId') as FormControl;
    this.group.value[this.controlName] = event.option.value;
  
    const selectedItem = this.list.find(item => item.clientName === formControl?.value);
    this.group.value['clientId'] = selectedItem?.clientId;
    this.prevSelectedCLient =   selectedItem?.clientName;
    //formControl.setValue(selectedItem?.clientId);
   formControlClientId?.setValue(selectedItem?.clientId);
    
   // this.currSelectedValue = selectedItem?.clientName;
    //formControl.setValue(this.currSelectedValue);
    let eventData = {
      value: selectedItem?.clientId
    }
    
   // formControl.setErrors(null);
   // formControl.updateValueAndValidity();

    this.optionSelected =true;
    this.filteredList = this.list;
    //this.onfocusOut();
   this.changeEvent.emit(eventData);
   this.clientChanged.emit(eventData);
   // this.optionSelectedEvent.emit(eventData);
    
  }

  /* istanbul ignore next */
onblur(event){
  setTimeout(() => {
    this.filteredList= this.list;
  }, 250);
 
}

 /**
     * @author HASHID
     * This This method clears the value of the form control 
     * and  Emits an event (`clearevent`) with a `true` value to notify 
     * that the selection has been cleared
     * Based on CCR3-6850
     */
clearSelection() {
  this.group.controls?.[this.controlName]?.setValue('');
  this.clearEvent?.emit(true)
  // this.clearSelectBtn.nativeElement.blur(); 
 }

checkInvalidClient(value){
  let formControl = this.group.get(this.controlName) as FormControl;
  if(value == null || value ==undefined){
    value='';

  }
  let client= this.list?.filter(option => option[this.description]?.toLowerCase()?.startsWith(value?.toLowerCase()));
 // let client= this.list?.filter(client => client?.clientName?.toLowerCase?.startsWith(value))
  if(this.controlName == 'clientNameDash'){
   if(client?.length != 0){
    this.rootScope.smartSearchData.isInvalidDashboardClient = false
    formControl?.setErrors(null);
   }
   else{
    this.rootScope.smartSearchData.isInvalidDashboardClient = true
    formControl?.setErrors({invalidDashboardClient:true});
    formControl?.markAllAsTouched();
   }
  }
  if(this.controlName == 'clientName'){
    if(client?.length != 0){
      this.rootScope.smartSearchData.isInvalidCustomerClient = false;
      //formControl.setErrors(null);
    }
    else{
      this.rootScope.smartSearchData.isInvalidCustomerClient = true;
      formControl?.setErrors({invalidClient:true});
      formControl?.markAllAsTouched();
    }
   }

}



}




